export default __webpack_public_path__ + "static/Hepatofelin-home-@1x-3f04b9bed383dcaa21c9fbee169f45fa.jpg";